var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWoodIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.897,
    height: 50.052,
    viewBox: "0 0 57.897 50.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wood_Floor_Icon",
    "data-name": "Wood Floor Icon",
    transform: "translate(0.04 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wood_Floor",
    "data-name": "Wood Floor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(22.989)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    y2: 5.517,
    transform: "translate(5.977)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y2: 5.517,
    transform: "translate(0.23 5.517)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    y2: 5.517,
    transform: "translate(11.265 11.035)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    y2: 5.517,
    transform: "translate(28.966)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    y2: 5.517,
    transform: "translate(23.219 5.517)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    y2: 5.517,
    transform: "translate(34.253 11.035)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 34.483,
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x2: 34.483,
    transform: "translate(0 33.104)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 34.483,
    transform: "translate(0 5.517)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 34.483,
    transform: "translate(0 11.035)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6-2",
    "data-name": "Line 6",
    y2: 5.517,
    transform: "translate(6.207)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-2",
    "data-name": "Line 9",
    y2: 5.517,
    transform: "translate(0.46 5.517)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11-2",
    "data-name": "Line 11",
    y2: 5.517,
    transform: "translate(11.494 11.035)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1-2",
    "data-name": "Line 1",
    x2: 34.483,
    transform: "translate(0.23)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x2: 34.483,
    transform: "translate(0 33.104)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2",
    "data-name": "Line 2",
    x2: 34.483,
    transform: "translate(0.23 5.517)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-2",
    "data-name": "Line 3",
    x2: 34.483,
    transform: "translate(0.23 11.035)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(22.989 16.552)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6-3",
    "data-name": "Line 6",
    y2: 5.517,
    transform: "translate(5.977)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-3",
    "data-name": "Line 9",
    y2: 5.517,
    transform: "translate(0.23 5.517)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11-3",
    "data-name": "Line 11",
    y2: 5.517,
    transform: "translate(11.265 11.035)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7-2",
    "data-name": "Line 7",
    y2: 5.517,
    transform: "translate(28.966)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-2",
    "data-name": "Line 8",
    y2: 5.517,
    transform: "translate(23.219 5.517)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10-2",
    "data-name": "Line 10",
    y2: 5.517,
    transform: "translate(34.253 11.035)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1-3",
    "data-name": "Line 1",
    x2: 34.483,
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-3",
    "data-name": "Line 2",
    x2: 34.483,
    transform: "translate(0 5.517)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-3",
    "data-name": "Line 3",
    x2: 34.483,
    transform: "translate(0 11.035)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(0.23 16.552)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6-4",
    "data-name": "Line 6",
    y2: 5.517,
    transform: "translate(5.977)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-4",
    "data-name": "Line 9",
    y2: 5.517,
    transform: "translate(0.23 5.517)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11-4",
    "data-name": "Line 11",
    y2: 5.517,
    transform: "translate(11.265 11.035)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1-4",
    "data-name": "Line 1",
    x2: 34.483,
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-4",
    "data-name": "Line 2",
    x2: 34.483,
    transform: "translate(0 5.517)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-4",
    "data-name": "Line 3",
    x2: 34.483,
    transform: "translate(0 11.035)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Wood_Floor-2",
    "data-name": "Wood Floor",
    transform: "translate(0.345 33.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56-2",
    "data-name": "Group 56",
    transform: "translate(22.759)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6-5",
    "data-name": "Line 6",
    y2: 5.517,
    transform: "translate(5.977)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-5",
    "data-name": "Line 9",
    y2: 5.517,
    transform: "translate(0.23 5.517)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11-5",
    "data-name": "Line 11",
    y2: 5.517,
    transform: "translate(11.265 11.035)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7-3",
    "data-name": "Line 7",
    y2: 5.517,
    transform: "translate(28.966)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-3",
    "data-name": "Line 8",
    y2: 5.517,
    transform: "translate(23.219 5.517)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10-3",
    "data-name": "Line 10",
    y2: 5.517,
    transform: "translate(34.253 11.035)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1-5",
    "data-name": "Line 1",
    x2: 34.483,
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-5",
    "data-name": "Line 2",
    x2: 34.483,
    transform: "translate(0 5.517)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-5",
    "data-name": "Line 3",
    x2: 34.483,
    transform: "translate(0 11.035)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57-2",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6-6",
    "data-name": "Line 6",
    y2: 5.517,
    transform: "translate(5.977)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-6",
    "data-name": "Line 9",
    y2: 5.517,
    transform: "translate(0.23 5.517)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11-6",
    "data-name": "Line 11",
    y2: 5.517,
    transform: "translate(11.265 11.035)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1-6",
    "data-name": "Line 1",
    x2: 34.483,
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-6",
    "data-name": "Line 2",
    x2: 34.483,
    transform: "translate(0 5.517)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-6",
    "data-name": "Line 3",
    x2: 34.483,
    transform: "translate(0 11.035)",
    fill: "none",
    stroke: "#02245a",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoodIcon);
export default __webpack_public_path__ + "static/media/woodIcon.89fc70028687f1129990faadf432549b.svg";
export { ForwardRef as ReactComponent };